import React, { Component } from "react";
import TransferInterbancaService from "../../../../services/transferencias/TransferInterbancaService";
import Popup from "react-popup";

import $ from "jquery";
//PopupAgreagrCuentaBasa
export default class PopupAgreagrCuentaBasa extends Component {

  constructor(props) {
    super(props);
    this.guardar = this.guardar.bind(this);
    this.validate = this.validate.bind(this);
    this.initData();
  }



  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  initData() {
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    entidadNew: "",
    nroCuentaNew: "",
    nombreApellidoNew: "",
    tipoDocNew: "",
    documentoNew: "",
  });

  guardar() {
    TransferInterbancaService.addCuentaExterna(
      this.state.nombreApellidoNew,
      this.state.nroCuentaNew,
      this.state.tipoDocNew,
      this.state.documentoNew,
      this.state.entidadNew
    )
      .then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigo === 0) {
          this.setState(this.getInitialState());
          this.modalCuenta.click();
          this.props.addCuentaCallback("OK");
        } else {
          Popup.queue(this.notifiPopup("Error", jData.mensaje));
          this.props.addCuentaCallback("FAIL");
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  validate = (e) => {
    $.validator.addMethod("dataType", (value, element) => {
      if (
        this.state.tipoDocNew === "3" &&
        isNaN(Number(this.state.documentoNew))
      ) {
        return false;
      }

      return true;
    });

    $("#idFormAddCuenta").validate({
      submitHandler: () => {
        this.guardar();
      },
      rules: {
        entidadNew: {
          required: true,
        },
        nroCuentaNew: {
          required: true,
        },
        nombreApellidoNew: {
          required: true,
        },
        tipoDocNew: {
          required: true,
        },
        documentoNew: {
          required: true,
          dataType: { dataType: true },
        },
      },
      messages: {
        entidadNew: {
          required: "Este campo es requerido",
        },
        nroCuentaNew: {
          required: "Este campo es requerido",
          number: "Favor ingrese un número válido, sin guión ni caracteres especiales",
        },
        nombreApellidoNew: {
          required: "Este campo es requerido",
        },
        tipoDocNew: {
          required: "Este campo es requerido",
        },
        documentoNew: {
          required: "Este campo es requerido",
          dataType: "Sólo números para Cédula de Identidad",
        },
      },
      errorElement: "span",
      errorPlacement: function (error, element) {
        error.addClass("invalid-feedback");
        element.closest(".form-group").append(error);
      },
      highlight: function (element, errorClass, validClass) {
        $(element).addClass("is-invalid");
      },
      unhighlight: function (element, errorClass, validClass) {
        $(element).removeClass("is-invalid");
      },
    });
  };

  changeTipoEntidad = (tipoEntidad) => {

    let newState = this.state;

    console.log(tipoEntidad);

  };

  render() {

    const listaTipoEntidad = this.state.tipoEntidadList.map((item) => (
      <option key={item} value={item}>
        {item}
      </option>
    ));

    listaTipoEntidad.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    const listItems = this.props.items.map((item) => (
      <option key={item.id} value={item.id}>
        {item.nombre}
      </option>
    ));

    listItems.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    const listTiposDocumentos = this.props.tipos.map((elemento) => (
      <option key={elemento.id} value={elemento.id}>
        {elemento.descripcion}
      </option>
    ));

    listTiposDocumentos.unshift(
      <option key="-1" value="" disabled>
        -- Seleccione--
      </option>
    );

    return (
      <form
        id="idFormAddCuenta"
        onSubmit={(e) => {
          e.preventDefault();
        }}
      >
        <div
          className="modal fade"
          id="modal-cuenta"
          data-backdrop="false"
        >
          <div className="modal-dialog  modal-dialog-centered  modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Datos de la Cuenta</h5>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Entidad</label>
                      <select
                        name="entidadNew"
                        value={this.state.entidadNew}
                        onChange={(selectedOption) => {
                          this.setState({
                            entidadNew: selectedOption.target.value,
                          });
                        }}
                        className="form-control input-box"
                        style={{ width: "100%" }}
                      >
                        {listItems}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nro. de Cuenta</label>
                      <input
                        placeholder="Ingresar sin guiones (-) o barras (/)"
                        name="nroCuentaNew"
                        value={this.state.nroCuentaNew}
                        type="number"
                        className="input-box form-control"
                        onChange={(val) => {
                          this.setState({ nroCuentaNew: val.target.value });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Nombre y Apellido</label>
                      <input
                        name="nombreApellidoNew"
                        value={this.state.nombreApellidoNew}
                        type="text"
                        className="input-box form-control"
                        onChange={(val) => {
                          this.setState({
                            nombreApellidoNew: val.target.value.toUpperCase(),
                          });
                        }}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Tipo de Documento</label>
                      <select
                        name="tipoDocNew"
                        value={this.state.tipoDocNew}
                        className="form-control input-box"
                        style={{ width: "100%" }}
                        onChange={(val) => {
                          this.setState({ tipoDocNew: val.target.value });
                        }}
                      >
                        {listTiposDocumentos}
                      </select>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label className="input-label">Documento</label>
                      <input
                        name="documentoNew"
                        value={this.state.documentoNew}
                        type="text"
                        className="input-box form-control"
                        onChange={(val) => {
                          this.setState({ documentoNew: val.target.value });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-cu-quintary"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    $("#idFormAddCuenta").validate().resetForm();
                    this.setState(this.getInitialState());
                  }}
                >
                  Cerrar
                </button>
                <button
                  className="btn btn-cu-primary"
                  onClick={() => {
                    this.validate();
                  }}
                >
                  Guardar
                </button>
              </div>
            </div>
            {/* /.modal-content */}
          </div>
          {/* /.modal-dialog */}
          <a
            data-controls-modal="modal-cuenta"
            ref={(a) => (this.modalCuenta = a)}
            data-backdrop="false"
            href="#"
            hidden
            id="showModalCuenta"
            data-toggle="modal"
            data-target={"#modal-cuenta"}
          ></a>
        </div>
      </form>
    );
  }
}
